import { render, staticRenderFns } from "./QuillEditor.vue?vue&type=template&id=1c66af46&scoped=true"
import script from "./QuillEditor.vue?vue&type=script&lang=js"
export * from "./QuillEditor.vue?vue&type=script&lang=js"
import style0 from "./QuillEditor.vue?vue&type=style&index=0&id=1c66af46&prod&scoped=true&lang=css"
import style1 from "./QuillEditor.vue?vue&type=style&index=1&id=1c66af46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c66af46",
  null
  
)

export default component.exports